import * as React from "react";
import { styled } from "@mui/material/styles";
import FormGroup from "@mui/material/FormGroup";
import Switch from "@mui/material/Switch";
import Stack from "@mui/material/Stack";
import "./switch.scss";

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 32,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked:not(.Mui-disabled)": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#a51890",
      },
    },
    "&.Mui-disabled": {
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "var(--black-40)",
      },
      "& .MuiSwitch-thumb": {
        width: 12,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    backgroundColor: "#fff",
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 20 / 2,
    opacity: 1,
    backgroundColor: "#a51890",
    boxSizing: "border-box",
  },
}));

export default function CustomizedSwitches(props) {
  return (
    <FormGroup className="switch-form">
      <Stack direction="row" spacing={1} alignItems="center">
        <span className="switch-label">{props.label1}</span>
        <AntSwitch
          className={props.disabled ? "prohibited-cursor" : ""}
          checked={props.checked}
          onChange={props.onChange}
          inputProps={{ "aria-label": "ant design" }}
          id={props.id}
          disabled={props.disabled}
        />
        <span className="switch-label">{props.label2}</span>
      </Stack>
    </FormGroup>
  );
}
